import CheckLoading from './CheckLoading';

export default CheckLoading;
